export const config = {
  eventGroup: 'mechabreak_pc_20250425',
  name: '《解限机》公测官网PC端',
  identify: 'codebreak',
  eventTags: ['pc', 'gongce']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadDownloadPage: function() {
      report({
        eventName: 'load_download_page',
        eventDescription: '下载页浏览',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickLjyy: function() {
      report({ eventName: 'click_ljyy', eventDescription: '首页-立即预约' });
    },
    clickLjyy3: function() {
      report({ eventName: 'click_ljyy3', eventDescription: '顶栏-立即预约' });
    },
    clickDownload: function() {
      report({ eventName: 'click_download', eventDescription: '首页-下载游戏' });
    },
    clickDownload2: function() {
      report({ eventName: 'click_download2', eventDescription: '顶栏-下载游戏' });
    },
    clickSteam: function() {
      report({ eventName: 'click_steam', eventDescription: '首页-steam' });
    },
    clickXbox: function() {
      report({ eventName: 'click_xbox', eventDescription: '首页-XBOX' });
    },
    clickCl: function(title, number) {
      // 手动调整，侧边栏埋点标记动态索引递增
      report({
        eventName: 'click_cl',
        eventDescription: '首页-侧栏',
        eventDataValue: { title: title, number: number },
        types: {
          number: checkTypeHOF('int'),
          title: checkTypeHOF('string')
        }
      });
    },
    clickYzm: function() {
      report({ eventName: 'click_yzm', eventDescription: '弹窗-验证码' });
    },
    clickLjyy2: function() {
      report({ eventName: 'click_ljyy2', eventDescription: '预约弹窗-立即预约' });
    },
    clickQdq: function() {
      report({ eventName: 'click_qdq', eventDescription: '下载页-启动器下载' });
    },
    clickSdyxz: function() {
      report({ eventName: 'click_sdyxz', eventDescription: '下载页-商店页下载' });
    },
    clickNew: function() {
      report({ eventName: 'click_new', eventDescription: '导航-新闻' });
    },
    clickNew2: function() {
      report({ eventName: 'click_new2', eventDescription: '导航-更多新闻' });
    },
    clickYxwf: function() {
      report({ eventName: 'click_yxwf', eventDescription: '导航-游戏玩法' });
    },
    clickJbjs: function() {
      report({ eventName: 'click_jbjs', eventDescription: '导航-机兵介绍' });
    },
    clickJbxq: function() {
      report({ eventName: 'click_jbxq', eventDescription: '内页-机兵详情' });
    },
    clickJblb: function() {
      report({ eventName: 'click_jblb', eventDescription: '内页-机兵列表' });
    },
    clickTzjxq: function() {
      report({ eventName: 'click_tzjxq', eventDescription: '内页-特装机详情' });
    },
    clickMsmk: function() {
      report({ eventName: 'click_msmk', eventDescription: '导航-玛什马克攻略站' });
    },
    clickDt6v6: function() {
      report({ eventName: 'click_dt6v6', eventDescription: '导航-地图-6v6' });
    },
    clickDt3v3: function() {
      report({ eventName: 'click_dt3v3', eventDescription: '导航-地图-3v3' });
    },
    clickSjg: function() {
      report({ eventName: 'click_sjg', eventDescription: '导航-世界观' });
    },
    clickKfzx: function() {
      report({ eventName: 'click_kfzx', eventDescription: '导航-客服中心' });
    },
    clickWpjh: function() {
      report({ eventName: 'click_wpjh', eventDescription: '导航-王牌计划' });
    },
    clickZbdb: function() {
      report({ eventName: 'click_zbdb', eventDescription: '导航-直播掉宝' });
    },
    clickGxrz: function() {
      report({ eventName: 'click_gxrz', eventDescription: '导航-高校认证' });
    },
    clickWbtq: function() {
      report({ eventName: 'click_wbtq', eventDescription: '导航-网吧特权' });
    },
    clickLbzx: function() {
      report({ eventName: 'click_lbzx', eventDescription: '导航-礼包中心' });
    },
    clickBilli: function() {
      report({ eventName: 'click_billi', eventDescription: '弹窗-进入B站' });
    },
    clickWeibo: function() {
      report({ eventName: 'click_weibo', eventDescription: '弹窗-进入微博' });
    },
    clickTxqq: function() {
      report({ eventName: 'click_txqq', eventDescription: '弹窗-进入QQ' });
    },
    clickVxgzh: function() {
      report({ eventName: 'click_vxgzh', eventDescription: '弹窗-微信公众号' });
    },
    clickDouyin: function() {
      report({ eventName: 'click_douyin', eventDescription: '弹窗-进入抖音' });
    },
    clickXhs: function() {
      report({ eventName: 'click_xhs', eventDescription: '弹窗-进入小红书' });
    },
    clickDclh: function() {
      report({ eventName: 'click_dclh', eventDescription: '导航-礼包中心-典藏礼盒' });
    },
    clickDplh: function() {
      report({ eventName: 'click_dplh', eventDescription: '导航-礼包中心-单品礼盒' });
    },
    clickFzlj: function() {
      report({ eventName: 'click_fzlj', eventDescription: '弹窗-复制链接' });
    },
    clickGcyl: function() {
      report({ eventName: 'click_gcyl', eventDescription: '首页-公测有礼' });
    },
    clickGcyllj: function() {
      report({ eventName: 'click_gcyllj', eventDescription: '弹窗-公测有礼领奖' });
    },
    clickGcylfz: function() {
      report({ eventName: 'click_gcylfz', eventDescription: '弹窗-公测有礼复制' });
    },
    clickGcylqd: function() {
      report({ eventName: 'click_gcylqd', eventDescription: '首页-公测有礼-渠道' });
    },
    clickGcylqdfz: function() {
      report({ eventName: 'click_gcylqdfz', eventDescription: '弹窗-公测有礼复制' });
    },
    clickZXPH: function() {
      report({ eventName: 'click_zxph', eventDescription: '导航-造型排行' });
    },
    // click_tzjjs
    clickTzjjs: function() {
      report({ eventName: 'click_tzjjs', eventDescription: '导航-游戏介绍-王牌档案' });
    },
    // click_tzjjsxq
    clickTzjjsxq: function() {
      report({ eventName: 'click_tzjjsxq', eventDescription: '王牌档案-查看详情' });
    },
    // click_bz
    clickBz: function() {
      report({ eventName: 'click_bz', eventDescription: '导航-作战资料-壁纸' });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
